import { combineReducers } from 'redux';
import {
  EMPLOYEE_STAFF_CLOSE_RIGHT_COLUMN,
  EMPLOYEE_STAFF_OPEN_RIGHT_COLUMN,
  EMPLOYEE_STAFF_SET_EMPLOYEES,
  EMPLOYEE_STAFF_SET_SUBMITTING,
  EMPLOYEE_STAFF_SET_EMPLOYEE_DETAIL,
  EMPLOYEE_STAFF_SET_OUTLETS,
  EMPLOYEE_STAFF_SET_ROLES,
  EMPLOYEE_STAFF_SHOW_ASSIGN_OUTLET_MODAL,
  EMPLOYEE_STAFF_HIDE_ASSIGN_OUTLET_MODAL,
  EMPLOYEE_STAFF_SHOW_EMPLOYEE_DELETE_MODAL,
  EMPLOYEE_STAFF_HIDE_EMPLOYEE_DELETE_MODAL,
  EMPLOYEE_STAFF_SHOW_RESEND_CAPTCHA_MODAL,
  EMPLOYEE_STAFF_HIDE_RESEND_CAPTCHA_MODAL,
  EMPLOYEE_STAFF_SET_RESEND_CAPTCHA_EMAIL,
  EMPLOYEE_STAFF_SET_CAN_ACCESS_ROLE,
  EMPLOYEE_STAFF_SHOW_PIN_REQUIRED_MODAL,
  EMPLOYEE_STAFF_HIDE_PIN_REQUIRED_MODAL,
  EMPLOYEE_STAFF_SET_PIN_REQUIRED_MODAL,
  EMPLOYEE_STAFF_SHOW_PURCHASE_STAFF_SLOT_MODAL,
  EMPLOYEE_STAFF_HIDE_PURCHASE_STAFF_SLOT_MODAL,
  EMPLOYEE_STAFF_SHOW_REACTIVATE_STAFF_MODAL,
  EMPLOYEE_STAFF_HIDE_REACTIVATE_STAFF_MODAL,
  EMPLOYEE_STAFF_SHOW_REACTIVATE_STAFF_NO_SLOT_MODAL,
  EMPLOYEE_STAFF_HIDE_REACTIVATE_STAFF_NO_SLOT_MODAL,
  EMPLOYEE_STAFF_SET_FEATURE_PRICE,
  EMPLOYEE_STAFF_SET_SLOT_DETAIL,
  EMPLOYEE_STAFF_SHOW_DEACTIVATE_STAFF_MODAL,
  EMPLOYEE_STAFF_HIDE_DEACTIVATE_STAFF_MODAL,
  EMPLOYEE_STAFF_SET_AVAILABLE_SLOTS,
  EMPLOYEE_STAFF_SET_ASSIGNED_EMPLOYEE,
  EMPLOYEE_STAFF_SET_PENDING_BILLING,
  EMPLOYEE_STAFF_SHOW_STOP_RENEWAL_MODAL,
  EMPLOYEE_STAFF_HIDE_STOP_RENEWAL_MODAL,
  EMPLOYEE_STAFF_SHOW_PAYMENT_GATEWAY_ERROR_MODAL,
  EMPLOYEE_STAFF_HIDE_PAYMENT_GATEWAY_ERROR_MODAL,
  EMPLOYEE_STAFF_DEACTIVATE_SET_ERROR_MESSAGE,
} from 'actions/employees/staff/constants';

import createReducer from 'utils/createReducer';

const assignedEmployee = createReducer(null, {
  [EMPLOYEE_STAFF_SET_ASSIGNED_EMPLOYEE]: (draft, { payload }) =>
    payload.assignedEmployee,
});

const availableSlots = createReducer([], {
  [EMPLOYEE_STAFF_SET_AVAILABLE_SLOTS]: (draft, { payload }) =>
    payload.availableSlots,
});

const canAccessRole = createReducer(null, {
  [EMPLOYEE_STAFF_SET_CAN_ACCESS_ROLE]: (draft, { payload }) =>
    payload.canAccessRole,
});

const employeeDetail = createReducer(null, {
  [EMPLOYEE_STAFF_SET_EMPLOYEE_DETAIL]: (draft, { payload }) =>
    payload.employee,
});

const employees = createReducer([], {
  [EMPLOYEE_STAFF_SET_EMPLOYEES]: (draft, { payload }) => payload.employees,
});

const featurePrice = createReducer(null, {
  [EMPLOYEE_STAFF_SET_FEATURE_PRICE]: (draft, { payload }) =>
    payload.featurePrice,
});

const openRightColumn = createReducer(false, {
  [EMPLOYEE_STAFF_CLOSE_RIGHT_COLUMN]: () => false,
  [EMPLOYEE_STAFF_OPEN_RIGHT_COLUMN]: () => true,
});

const outlets = createReducer([], {
  [EMPLOYEE_STAFF_SET_OUTLETS]: (draft, { payload }) => payload.outlets,
});

const pendingBilling = createReducer(null, {
  [EMPLOYEE_STAFF_SET_PENDING_BILLING]: (draft, { payload }) => payload.billing,
});

const pinRequiredModal = createReducer(
  {
    message: '',
  },
  {
    [EMPLOYEE_STAFF_SET_PIN_REQUIRED_MODAL]: (draft, { payload }) => ({
      ...payload,
    }),
  }
);

const resendCaptchaEmail = createReducer(null, {
  [EMPLOYEE_STAFF_SET_RESEND_CAPTCHA_EMAIL]: (draft, { payload }) =>
    payload.email,
});

const roles = createReducer([], {
  [EMPLOYEE_STAFF_SET_ROLES]: (draft, { payload }) => payload.roles,
});

const showAssignOutletModal = createReducer(false, {
  [EMPLOYEE_STAFF_SHOW_ASSIGN_OUTLET_MODAL]: () => true,
  [EMPLOYEE_STAFF_HIDE_ASSIGN_OUTLET_MODAL]: () => false,
});

const showDeactivateEmployeeErrorMessage = createReducer(null, {
  [EMPLOYEE_STAFF_HIDE_DEACTIVATE_STAFF_MODAL]: () => null,

  [EMPLOYEE_STAFF_DEACTIVATE_SET_ERROR_MESSAGE]: (draft, { payload }) =>
    payload.message,
});

const showDeactivateModal = createReducer(false, {});

const showDeactivateStaffModal = createReducer(false, {
  [EMPLOYEE_STAFF_SHOW_DEACTIVATE_STAFF_MODAL]: () => true,
  [EMPLOYEE_STAFF_HIDE_DEACTIVATE_STAFF_MODAL]: () => false,
});

const showEmployeeDeleteModal = createReducer(false, {
  [EMPLOYEE_STAFF_SHOW_EMPLOYEE_DELETE_MODAL]: () => true,
  [EMPLOYEE_STAFF_HIDE_EMPLOYEE_DELETE_MODAL]: () => false,
});

const showPaymentGatewayErrorModal = createReducer(false, {
  [EMPLOYEE_STAFF_SHOW_PAYMENT_GATEWAY_ERROR_MODAL]: () => true,
  [EMPLOYEE_STAFF_HIDE_PAYMENT_GATEWAY_ERROR_MODAL]: () => false,
});

const showPinRequiredModal = createReducer(false, {
  [EMPLOYEE_STAFF_SHOW_PIN_REQUIRED_MODAL]: () => true,
  [EMPLOYEE_STAFF_HIDE_PIN_REQUIRED_MODAL]: () => false,
});

const showPurchaseStaffSlotModal = createReducer(false, {
  [EMPLOYEE_STAFF_SHOW_PURCHASE_STAFF_SLOT_MODAL]: () => true,
  [EMPLOYEE_STAFF_HIDE_PURCHASE_STAFF_SLOT_MODAL]: () => false,
});

const showReactivateStaffModal = createReducer(false, {
  [EMPLOYEE_STAFF_SHOW_REACTIVATE_STAFF_MODAL]: () => true,
  [EMPLOYEE_STAFF_HIDE_REACTIVATE_STAFF_MODAL]: () => false,
});

const showReactivateStaffNoSlotModal = createReducer(false, {
  [EMPLOYEE_STAFF_SHOW_REACTIVATE_STAFF_NO_SLOT_MODAL]: () => true,
  [EMPLOYEE_STAFF_HIDE_REACTIVATE_STAFF_NO_SLOT_MODAL]: () => false,
});

const showResendCaptchaModal = createReducer(false, {
  [EMPLOYEE_STAFF_SHOW_RESEND_CAPTCHA_MODAL]: () => true,
  [EMPLOYEE_STAFF_HIDE_RESEND_CAPTCHA_MODAL]: () => false,
});

const showStopRenewalModal = createReducer(false, {
  [EMPLOYEE_STAFF_SHOW_STOP_RENEWAL_MODAL]: () => true,
  [EMPLOYEE_STAFF_HIDE_STOP_RENEWAL_MODAL]: () => false,
});

const slotDetail = createReducer(null, {
  [EMPLOYEE_STAFF_SET_SLOT_DETAIL]: (draft, { payload }) => payload.slotDetail,
});

const submitting = createReducer(null, {
  [EMPLOYEE_STAFF_SET_SUBMITTING]: (draft, { payload }) => payload.submitting,
});

export default combineReducers({
  assignedEmployee,
  availableSlots,
  canAccessRole,
  employeeDetail,
  employees,
  featurePrice,
  openRightColumn,
  outlets,
  pendingBilling,
  pinRequiredModal,
  resendCaptchaEmail,
  roles,
  showAssignOutletModal,
  showDeactivateEmployeeErrorMessage,
  showDeactivateModal,
  showDeactivateStaffModal,
  showEmployeeDeleteModal,
  showPaymentGatewayErrorModal,
  showPinRequiredModal,
  showPurchaseStaffSlotModal,
  showReactivateStaffModal,
  showReactivateStaffNoSlotModal,
  showResendCaptchaModal,
  showStopRenewalModal,
  slotDetail,
  submitting,
});
